/* unplugin-vue-components disabled */import { render } from "./videoAssembly.vue?vue&type=template&id=486bcd7f"
import script from "./videoAssembly.vue?vue&type=script&lang=js"
export * from "./videoAssembly.vue?vue&type=script&lang=js"

import exportComponent from "/Users/huangzhichao/Code/beyoung/weitu_land_page_h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__